import { render, staticRenderFns } from "./VirtualDeviceItem.vue?vue&type=template&id=df5377a8&scoped=true&"
import script from "./VirtualDeviceItem.vue?vue&type=script&lang=js&"
export * from "./VirtualDeviceItem.vue?vue&type=script&lang=js&"
import style0 from "./VirtualDeviceItem.vue?vue&type=style&index=0&id=df5377a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5377a8",
  null
  
)

export default component.exports